import { Color } from "../maths/Color";
import { MathUtil } from "../maths/MathUtil";
import { Rectangle } from "../maths/Rectangle";
import { Vector3 } from "../maths/Vector3";
import { Pool } from "./Pool";
export class VertexStream {
    constructor() {
        this._vp = 0;
        this._ip = 0;
        this._epv = 0;
        this.contentRect = new Rectangle();
        this.uvRect = new Rectangle();
        this.color = new Color();
        this._epv = 9;
        this._vbuf = new ArrayBuffer(Float32Array.BYTES_PER_ELEMENT * this._epv * 10);
        this._vertices = new Float32Array(this._vbuf);
        this._ibuf = new ArrayBuffer(Uint16Array.BYTES_PER_ELEMENT * 3 * 10);
        this._indices = new Uint16Array(this._ibuf);
        this._vec = new Vector3();
    }
    init(mainTex, hasColor) {
        this.mainTex = mainTex;
        if (mainTex) {
            let uv = mainTex.uvrect;
            if (mainTex.width === mainTex.sourceWidth && mainTex.height === mainTex.sourceHeight)
                this.uvRect.setTo(uv[0], uv[1], uv[2], uv[3]);
            else {
                let sx = uv[2] / mainTex.width;
                let sy = uv[3] / mainTex.height;
                this.uvRect.setTo(uv[0] - mainTex.offsetX * sx, uv[1] - mainTex.offsetY * sy, mainTex.sourceWidth * sx, mainTex.sourceHeight * sy);
            }
        }
        else
            this.uvRect.setTo(0, 0, 1, 1);
        this._epv = hasColor ? 9 : 5;
        this.color.setValue(1, 1, 1, 1);
        this._vp = 0;
        this._ip = 0;
    }
    addVert(x, y, z, color, u, v) {
        this.checkVBuf(this._epv);
        let arr = this._vertices;
        let idx = this._vp;
        this._vp += this._epv;
        arr[idx] = x;
        arr[idx + 1] = y;
        arr[idx + 2] = z;
        if (u != null)
            arr[idx + 3] = u;
        else
            arr[idx + 3] = MathUtil.lerp(this.uvRect.x, this.uvRect.right, (x - this.contentRect.x) / (this.contentRect.width || 1));
        if (v != null)
            arr[idx + 4] = v;
        else
            arr[idx + 4] = MathUtil.lerp(this.uvRect.y, this.uvRect.bottom, (y - this.contentRect.y) / (this.contentRect.height || 1));
        if (this._epv === 9)
            (color || this.color).writeTo(arr, idx + 5);
    }
    addQuad(rect, color, uvRect) {
        if (uvRect) {
            this.addVert(rect.x, rect.y, 0, color, uvRect.x, uvRect.y);
            this.addVert(rect.right, rect.y, 0, color, uvRect.right, uvRect.y);
            this.addVert(rect.right, rect.bottom, 0, color, uvRect.right, uvRect.bottom);
            this.addVert(rect.x, rect.bottom, 0, color, uvRect.x, uvRect.bottom);
        }
        else {
            this.addVert(rect.x, rect.y, 0, color);
            this.addVert(rect.right, rect.y, 0, color);
            this.addVert(rect.right, rect.bottom, 0, color);
            this.addVert(rect.x, rect.bottom, 0, color);
        }
    }
    addTriangle(idx0, idx1, idx2) {
        this.checkIBuf(3);
        this._indices[this._ip++] = idx0;
        this._indices[this._ip++] = idx1;
        this._indices[this._ip++] = idx2;
    }
    addTriangles(indices) {
        this.checkIBuf(indices.length);
        let arr = this._indices;
        let idx = this._ip;
        let n = indices.length;
        this._ip += n;
        for (let i = 0; i < n; i++)
            arr[idx + i] = indices[i];
    }
    triangulateQuad(baseIndex) {
        let cnt = this._vp / this._epv;
        if (baseIndex < 0)
            baseIndex = cnt + baseIndex;
        let icnt = (cnt - baseIndex) / 4 * 6;
        this.checkIBuf(icnt);
        let arr = this._indices;
        for (let i = baseIndex, j = this._ip; i < cnt; i += 4, j += 6) {
            arr[j] = i;
            arr[j + 1] = i + 1;
            arr[j + 2] = i + 2;
            arr[j + 3] = i + 2;
            arr[j + 4] = i + 3;
            arr[j + 5] = i;
        }
        this._ip += icnt;
    }
    getPos(index) {
        if (index < 0)
            index = this._vp / this._epv + index;
        index *= this._epv;
        this._vec.set(this._vertices[index], this._vertices[index + 1], this._vertices[index + 2]);
        return this._vec;
    }
    get vertCount() {
        return this._vp / this._epv;
    }
    get vertexStride() {
        return this._epv;
    }
    getVertices() {
        return new Float32Array(this._vbuf, 0, this._vp);
    }
    getIndices() {
        return new Uint16Array(this._ibuf, 0, this._ip);
    }
    checkVBuf(addCount) {
        if (this._vp + addCount >= this._vertices.length) {
            this._vbuf = new ArrayBuffer(this._vbuf.byteLength + Float32Array.BYTES_PER_ELEMENT * this._epv * Math.max(10, addCount));
            let tmp = this._vertices;
            this._vertices = new Float32Array(this._vbuf);
            this._vertices.set(tmp);
        }
    }
    checkIBuf(addCount) {
        if (this._ip + addCount >= this._indices.length) {
            this._ibuf = new ArrayBuffer(this._ibuf.byteLength + Uint16Array.BYTES_PER_ELEMENT * 3 * Math.max(10, addCount));
            let tmp = this._indices;
            this._indices = new Uint16Array(this._ibuf);
            this._indices.set(tmp);
        }
    }
}
VertexStream.pool = Pool.createPool(VertexStream, (e, mainTex, hasColor) => e.init(mainTex, hasColor));
